import React, { useState } from 'react';
import Sidebar from '../components/Sidebar';
import AlgaChat from '../components/AlgaChat';
import { XIcon } from 'lucide-react';
const AlgaPage = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  return <div className="flex h-screen bg-gray-100" data-id="element-1448">
      {/* Mobile sidebar */}
      <div className={`fixed inset-0 z-40 md:hidden ${sidebarOpen ? 'block' : 'hidden'}`} data-id="element-1449">
        {/* Sidebar backdrop */}
        <div className="fixed inset-0 bg-gray-600 bg-opacity-75" onClick={() => setSidebarOpen(false)} data-id="element-1450"></div>
        {/* Sidebar */}
        <div className="relative flex-1 flex flex-col w-2/3 h-full bg-black" data-id="element-1451">
          <div className="absolute top-0 right-0 -mr-12 pt-2" data-id="element-1452">
            <button type="button" className="ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white" onClick={() => setSidebarOpen(false)} data-id="element-1453">
              <span className="sr-only" data-id="element-1454">Close sidebar</span>
              <XIcon className="h-6 w-6 text-white" aria-hidden="true" data-id="element-1455" />
            </button>
          </div>
          <div className="flex-1 h-full overflow-y-auto" data-id="element-1456">
            <Sidebar activePage="alga" data-id="element-1457" />
          </div>
        </div>
      </div>
      {/* Static sidebar for desktop */}
      <div className="hidden md:flex md:flex-shrink-0" data-id="element-1458">
        <Sidebar activePage="alga" data-id="element-1459" />
      </div>
      <div className="flex flex-col flex-1 overflow-hidden" data-id="element-1460">
        <AlgaChat onMenuClick={() => setSidebarOpen(true)} data-id="element-1461" />
      </div>
    </div>;
};
export default AlgaPage;